import { SaveBuyProductUsecase, SaveBuyProductUsecaseImp } from 'domain/usecases/save-buy-product-usecase';
import { makeHttpSaveBuyProductRepository } from '../repositories/http/product-http-repository-factory';

export const makeSaveBuyProductUsecase = (): SaveBuyProductUsecase => {
  return new SaveBuyProductUsecaseImp(makeHttpSaveBuyProductRepository());
};
